import { useContext, useEffect, useState } from "react";
import { MdArrowForward, MdCalendarToday, MdZoomOutMap } from "react-icons/md";
import { AppContext } from "../App";
import { CDN_URL, getInlineLoader } from "../Helpers";
import fallbackImage from "../assets/banner-removebg-preview.png";

function formatGalleryDate(timestamp) {
  if (!timestamp) {
    return "Recently added";
  }

  const date = String(timestamp).length <= 10
    ? new Date(Number(timestamp) * 1000)
    : new Date(timestamp);

  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
}

export default function HomeGallerySection() {
  const appContext = useContext(AppContext);
  const [latestGalleryItems, setLatestGalleryItems] = useState([]);
  const [loading, setLoading] = useState(true);

  function goToGallery() {
    appContext.navTo({
      item: "gallery",
    });
  }

  useEffect(() => {
    let mounted = true;

    async function loadGallery() {
      setLoading(true);
      const gallery = await appContext.getAllGallery({ limit: 3 });
      if (mounted) {
        setLatestGalleryItems(gallery);
        setLoading(false);
      }
    }

    loadGallery();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section className="MainBodySection home-gallery-section">
      <div className="container">
        <div className="home-section-head home-gallery-head">
          <div data-aos="fade-up">
            <p className="home-banner-kicker">Latest Portfolio</p>
            <h2 className="home-service-title font-bold">Recent Work Worth Seeing</h2>
          </div>

          <button
            type="button"
            className="home-section-link"
            onClick={goToGallery}
            data-aos="fade-left"
          >
            Open Portfolio
            <MdArrowForward size={20} />
          </button>
        </div>

        {loading ? (
          <div className="mSupportLoading" style={{ minHeight: 360 }}>
            {getInlineLoader()}
          </div>
        ) : latestGalleryItems.length > 0 ? (
          <div className="home-gallery-layout">
            {latestGalleryItems.map((item, index) => (
              <article
                className={`home-gallery-card ${
                  index === 0 ? "home-gallery-card-large" : ""
                }`}
                key={item.uuid || item.id}
                data-aos="fade-up"
                data-aos-delay={index * 90}
                role="button"
                tabIndex={0}
                onClick={goToGallery}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    goToGallery();
                  }
                }}
              >
                <img
                  src={item.photo ? CDN_URL + item.photo : fallbackImage}
                  alt={item.title || item.description || "Esmeriser gallery item"}
                />
                <div className="home-gallery-card-shade" />
                <span className="home-gallery-card-action">
                  <MdZoomOutMap size={18} />
                </span>
                <div className="home-gallery-card-copy">
                  <h3 className="font-bold">{item.title || "Gallery Item"}</h3>
                  <p>{item.description || "A recent Esmeriser portfolio item."}</p>
                  <small>
                    <MdCalendarToday size={14} />
                    {formatGalleryDate(item.dateCreated || item.date)}
                  </small>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="home-empty-state">
            <h3 className="font-bold">Gallery work is coming soon.</h3>
            <p>Published gallery records from the admin panel will appear here.</p>
          </div>
        )}
      </div>
    </section>
  );
}
